<template>
  <v-container id="search-page">
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <v-row class="my-10">
      <v-col>
        <span class="text-tcdc-green header bold">{{ $t('searchPage.search') }}</span>
      </v-col>
    </v-row>
    <v-layout mb-3>
      <v-icon large mr-2 class="borderbot-searchmain">mdi-magnify</v-icon>
      <v-text-field
          id="search-main"
          solo
          flat
          shaped
          hide-details
          color="#34A93E"
          height="60"
          class="borderbot-searchmain"
          background-color="transparent"
          :placeholder="$t('appbar.search')"
          v-model="keywordSearch"
          @keyup.enter="onSearch(keywordSearch)"
      ></v-text-field>
    </v-layout>
    <v-tabs color="#34A93E" v-model="mode" class="mb-7">
      <v-tab>{{ $t('searchPage.programs') }}</v-tab>
      <v-tab>{{ $t('searchPage.articles') }}</v-tab>
      <v-tab>{{ $t('searchPage.ebooks') }}</v-tab>
      <v-tab>{{ $t('searchPage.onlineExs') }}</v-tab>
    </v-tabs>
    <div v-if="mode === 0 && searchProgramResult">
      <v-list v-if="searchProgramResult.data.length > 0">
        <v-list-item v-for="(item, i) in searchProgramResult.data" :key="i" class="mb-3">
          <v-layout column>
            <v-layout align-center>
              <v-flex shrink mr-3 cursor-pointer @click="seeDetail('program', item.product_id)">
                <v-img
                    v-if="item.img_cover_mobile || item.img_cover_desktop"
                    eager
                    :src="'https://event.tcdc.or.th/' + (item.img_cover_mobile ? item.img_cover_mobile:item.img_cover_desktop)"
                    width="60px"
                    height="60px"
                    style="border-radius: 4px;"
                />
                <v-img
                    v-else
                    eager
                    :src="require('../../assets/uploadImage.jpg')"
                    width="60px"
                    height="60px"
                    style="border-radius: 4px;"
                />
              </v-flex>
              <v-flex>
                <div class="text-tcdc-green bold cursor-pointer" @click="seeDetail('program', item.product_id)" v-html="item[`name_${lang}`] ? item[`name_${lang}`] : item.name_th">

                </div>
                <div v-if="item.event_type" class="grey--text">Type: {{ item.event_type }}</div>
              </v-flex>
            </v-layout>
            <v-divider class="mt-3"/>
          </v-layout>
        </v-list-item>
      </v-list>
      <div v-else class="grey--text text-center">
        {{ $t('searchPage.no-record') }}
      </div>
      <v-pagination
          v-if="searchProgramResult && searchProgramResult.data.length > 0"
          v-model="searchProgramResult.current_page"
          :total-visible="7"
          :length="searchProgramResult.last_page"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          color="#2e8037"
          @input="onPageChange"
      ></v-pagination>
    </div>
    <div v-if="mode === 1 && searchArticleResult">
      <v-list v-if="searchArticleResult.data.length > 0">
        <v-list-item v-for="(item, i) in searchArticleResult.data" :key="i" class="mb-3">
          <v-layout column>
            <v-layout align-center>
              <v-flex shrink mr-3 cursor-pointer @click="seeDetail('article', item.article_id, item.slug)">
                <v-img
                    v-if="item.cover_img_path"
                    eager
                    :src="item.cover_img_path"
                    width="60px"
                    height="60px"
                    style="border-radius: 4px;"
                />
                <v-img
                    v-else
                    eager
                    :src="require('../../assets/uploadImage.jpg')"
                    width="60px"
                    height="60px"
                    style="border-radius: 4px;"
                />
              </v-flex>
              <v-flex>
                <div class="text-tcdc-green bold cursor-pointer" @click="seeDetail('article', item.article_id, item.slug)">
                  {{ item[`subject_${lang}`] ? item[`subject_${lang}`] : item.subject_th }}
                </div>
              </v-flex>
            </v-layout>
            <v-divider class="mt-3"/>
          </v-layout>
        </v-list-item>
      </v-list>
      <div v-else class="grey--text text-center">
        {{ $t('searchPage.no-record') }}
      </div>
      <v-pagination
          v-if="searchArticleResult && searchArticleResult.data.length > 0"
          v-model="searchArticleResult.current_page"
          :total-visible="7"
          :length="searchArticleResult.last_page"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          color="#2e8037"
          @input="onPageChange"
      ></v-pagination>
    </div>
    <div v-if="mode === 2 && searchEbookResult">
      <v-list v-if="searchEbookResult.data.length > 0">
        <v-list-item v-for="(item, i) in searchEbookResult.data" :key="i" class="mb-3">
          <v-layout column>
            <v-layout align-center>
              <v-flex shrink mr-3 cursor-pointer @click="seeDetail('ebook', item.article_id, item.slug)">
                <v-img
                    v-if="item.cover_img_path"
                    eager
                    :src="item.cover_img_path"
                    width="60px"
                    height="60px"
                    style="border-radius: 4px;"
                />
                <v-img
                    v-else
                    eager
                    :src="require('../../assets/uploadImage.jpg')"
                    width="60px"
                    height="60px"
                    style="border-radius: 4px;"
                />
              </v-flex>
              <v-flex>
                <div class="text-tcdc-green bold cursor-pointer" @click="seeDetail('ebook', item.article_id, item.slug)">
                  {{ item[`subject_${lang}`] ? item[`subject_${lang}`] : item.subject_th }}
                </div>
              </v-flex>
            </v-layout>
            <v-divider class="mt-3"/>
          </v-layout>
        </v-list-item>
      </v-list>
      <div v-else class="grey--text text-center">
        {{ $t('searchPage.no-record') }}
      </div>
      <v-pagination
          v-if="searchEbookResult && searchEbookResult.data.length > 0"
          v-model="searchEbookResult.current_page"
          :total-visible="7"
          :length="searchEbookResult.last_page"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          color="#2e8037"
          @input="onPageChange"
      ></v-pagination>
    </div>
    <div v-if="mode === 3 && searchOnlineExResult">
      <v-list v-if="searchOnlineExResult.data.length > 0">
        <v-list-item v-for="(item, i) in searchOnlineExResult.data" :key="i" class="mb-3">
          <v-layout column>
            <v-layout align-center>
              <v-flex shrink mr-3 cursor-pointer @click="seeDetail('onlineEx', item.id)">
                <v-img
                    v-if="item.cover_image"
                    :src="item.cover_image"
                    width="60px"
                    height="60px"
                    style="border-radius: 4px;"
                />
                <v-img
                    v-else
                    eager
                    :src="require('../../assets/uploadImage.jpg')"
                    width="60px"
                    height="60px"
                    style="border-radius: 4px;"
                />
              </v-flex>
              <v-flex>
                <div class="text-tcdc-green bold cursor-pointer" @click="seeDetail('onlineEx', item.id)">
                  {{ item[`title_${lang}`] ? item[`title_${lang}`] : item.title_th }}
                </div>
              </v-flex>
            </v-layout>
            <v-divider class="mt-3"/>
          </v-layout>
        </v-list-item>
      </v-list>
      <div v-else class="grey--text text-center">
        {{ $t('searchPage.no-record') }}
      </div>
      <v-pagination
          v-if="searchOnlineExResult && searchOnlineExResult.data.length > 0"
          v-model="searchOnlineExResult.current_page"
          :total-visible="7"
          :length="searchOnlineExResult.last_page"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          color="#2e8037"
          @input="onPageChange"
      ></v-pagination>
    </div>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';
import Loading from 'vue-loading-overlay';
import {Utils} from "@/util/Utils";

export default {
  components: {
    Loading
  },
  created() {
    this.items[0].text = this.branchName;
    let path;
    for (const b of this.allBranches) {
      if (this.branchId === b.branch_id) {
        if (this.branchId === 0) {
          path = `/home`;
          break;
        }
        path = `/home/${b.tag_name}`;
        break;
      }
    }
    this.items[0].to = path;

    if (this.$route.query.tab) {
      const tab = this.$route.query.tab
      this.setTab(tab)
    }

    if (this.$route.query.keyword) {
      const routeKey = this.$route.query.keyword
      this.keywordSearch = routeKey
      this.onSearch(routeKey)
    } else {
      if (this.keyword) {
        this.keywordSearch = this.keyword;
        this.onSearch(this.keywordSearch)
      }
    }
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      branchId: state => state.Branch.branch_id,
      tag_name: state => state.Branch.tag_name,
      lang: state => state.Branch.lang,
      keyword: state => state.Search.keyword,
      // searchProgramResult: state => {
      //   if (state.Search.result.program) {
      //     return state.Search.result.program;
      //   }
      // },
      // searchArticleResult: state => {
      //   if (state.Search.result.article) {
      //     return state.Search.result.article;
      //   }
      // }
    }),
    branchChanged: function () {
      return this.branchName;
    },
    keywordChanged: function () {
      return this.keywordSearch;
    }
  },
  watch: {
    branchChanged: function () {
      this.items[0].text = this.branchChanged;
      let path;
      for (const b of this.allBranches) {
        if (this.branchId === b.branch_id) {
          if (this.branchId === 0) {
            path = `/home`;
            break;
          }
          path = `/home/${b.tag_name}`;
          break;
        }
      }
      this.items[0].to = path;
    },
    keywordChanged: function () {
      this.$store.dispatch('Search/onSetKeyword', this.keywordSearch);
    }
  },
  methods: {
    async onSearch(keyword) {
      if (keyword) {
        await this.$store.dispatch('Search/onClearResult');
        // v-tab mode (0 = program, 1 = article, 2 = ebook, 3 = onlineEx)
        // API store mode (0 = program, 1 = article, 3 = ebook, 4 = onlineEx)
        this.isLoading = true;

        let payload = {
          keyword: keyword,
          page: 1
        };

        let program = {
          ...payload,
          tag: this.tag_name,
          mode: 0
        };
        let article = {
          ...payload,
          mode: 1
        };
        let ebook = {
          ...payload,
          mode: 3
        };
        let onlineEx = {
          ...payload,
          mode: 4
        };

        await Promise.all([
          this.$store.dispatch('Search/onSearch', program),
          this.$store.dispatch('Search/onSearch', article),
          this.$store.dispatch('Search/onSearch', ebook),
          this.$store.dispatch('Search/onSearch', onlineEx)
        ]).then(res => {
          // console.log(res)
          this.searchProgramResult = res[0]
          this.searchArticleResult = res[1]
          this.searchEbookResult = res[2]
          this.searchOnlineExResult = res[3]
          this.isLoading = false;
        }).catch(() => {
          this.isLoading = false;
        })
      }
      if (this.$route.query.keyword !== keyword) {
        this.$router.push({ name: 'Search', query: { keyword: keyword } })
      }
      this.isLoading = false;
    },
    async onPageChange(page) {
      this.isLoading = true;
      let payload = {
        keyword: this.keywordSearch,
        page: page
      }
      switch (this.mode) {
        case 0:
          payload = {
            ...payload,
            tag: this.tag_name,
            mode: 0
          }
          break;

        case 1:
          payload = {
            ...payload,
            mode: 1
          }
          break;

        case 2:
          payload = {
            ...payload,
            mode: 3
          }
          break;

        case 3:
          payload = {
            ...payload,
            mode: 4
          }
          break;
      }
      await this.$store.dispatch('Search/onSearch', payload);
      this.isLoading = false;
    },
    openLink(url) {
      if (url) {
        window.open(url);
      }
    },
    seeDetail(mode, id, slug = '') {
      if (slug) slug = slug.replace(/ /g, '-')
      if (id) {
        const branch = Utils.getBranchNameById(this.branchId, this.allBranches);
        switch (mode) {
          case 'program':
            // this.$router.push({ name: "EventDetail", params: { id: id, branch: branch } });
            this.$router.push(`/${this.lang}` + `${branch}/events/${id}`);
            break;

          case 'article':
            // this.$router.push({ name: "ArticleDetail", params: { id: id, branch: branch } });
            this.$router.push(`/${this.lang}` + `${branch}/service/resource-center/article/${id + (slug ? '-' + slug : '')}`);
            break;

          case 'ebook':
            this.$router.push(`/${this.lang}` + `${branch}/service/resource-center/e-book/${id + (slug ? '-' + slug : '')}`);
            break;

          case 'onlineEx':
            this.$router.push(`/${this.lang}` + `${branch}/service/resource-center/online-exhibition/${id}`);
            break;
        }
      }
    },
    setTab(mode) {
      switch (mode) {
        case 'program':
          this.mode = 0
          break

        case 'article':
          this.mode = 1
          break

        case 'ebook':
          this.mode = 2
          break

        case 'onlineEx':
          this.mode = 3
          break

        default:
          this.mode = 0
      }
    }
  },
  beforeDestroy() {
    this.$store.dispatch('Search/onClearResult');
    this.$store.dispatch('Search/onResetKeyword');
  },
  data: () => ({
    items: [
      {
        text: 'TCDC BANGKOK',
        to: "/home"
      },
      {
        text: "SEARCH",
      }
    ],
    mode: 0,
    isLoading: false,
    keywordSearch: "",
    searchProgramResult: null,
    searchArticleResult: null,
    searchEbookResult: null,
    searchOnlineExResult: null
  })
};
</script>

<style lang="scss">
.borderbot-searchmain {
  border-bottom: solid 2px #34A93E;
}

.theme--light.v-input input#search-main,
input#search-main::placeholder {
  font-size: 1.5rem;
  line-height: 36px;
  font-family: "Poppins", "Kanit", sans-serif;
}

.v-text-field input#search-main,
.v-text-field input#search-box {
  height: 60px !important;
  max-height: unset !important;
  font-family: "Poppins", "Kanit", sans-serif;
}

</style>
